import { render, staticRenderFns } from "./EmailItem.vue?vue&type=template&id=69f6cefc&"
import script from "./EmailItem.vue?vue&type=script&lang=js&"
export * from "./EmailItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports